/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Ogsitename2Inputs */

const ja_metadata_ogsitename2 = /** @type {(inputs: Metadata_Ogsitename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン`)
};

const en_metadata_ogsitename2 = /** @type {(inputs: Metadata_Ogsitename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Inc`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Inc" |
*
* @param {Metadata_Ogsitename2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_ogsitename2 = /** @type {((inputs?: Metadata_Ogsitename2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Ogsitename2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_ogsitename2(inputs)
	return en_metadata_ogsitename2(inputs)
});
export { metadata_ogsitename2 as "metadata_ogSiteName" }